import React from "react";
import ProductSummary from "./summary";
import ProductOptions from "components/product/options";
import AddToCart from "components/add-to-cart";
import Image from "components/image";
import ServiceInfo from "./service-info";

const ProductInfo = ({ product, quantityConfig, secureCheckout, warranty, logistics }) => {
	const { title, type, handle, variant, variants, options, id, previewImageUrl } = product;

	return (
		<div id="product-info"
			className="md:pr-6 xl:pr-0 md:pl-4 pt-4 md:pt-0 sticky top-24 max-w-[470px] xxl:pr-2">
			<div className="flex flex-col gap-4 md:gap-6 px-4 md:px-0">
				<ProductSummary product={product} />
				<div className="flex flex-col gap-2">
					<div className="flex flex-col gap-4">
						<ProductOptions
							variants={variants}
							options={options}
							handle={handle}
							variant={variant}
						/>
						<AddToCart
							quantityConfig={quantityConfig}
							product={{ title, id, variant, variants, type, previewImageUrl, handle }}
							warranty={warranty}
							hideWishlistIcon
						/>
					</div>
					<div className="flex justify-center">
						<Image className="px-4 max-w-[600px]" image={secureCheckout} />
					</div>
				</div>
				<ServiceInfo logistics={logistics} variant={variant} />
			</div>
		</div>
	);
};

export default ProductInfo;